// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import api from 'utils/api';
import { Field, reduxForm } from 'utils/reduxFormWrapper';
import { required } from 'utils/validation';
import HForm from 'shared/containers/portal_layout/HForm';
import Errors from 'shared/components/Errors';
import FlashMessageActions from 'shared/actions/FlashMessageActions';
import { connect } from 'react-redux';
import { ReminderDateInput } from './ReminderDateInput';
import NoteInput from './NoteInput';
import addBusinessDays from 'date-fns/addBusinessDays';
import { iso8601Date } from 'preferral-common/utils/dateFormatters';

const tomorrow = addBusinessDays(new Date(), 1);

class ReferralReminderCreator extends Component {
  constructor(props) {
    super(props);
    this.createReminder = this.createReminder.bind(this);
  }

  createReminder(formValues) {
    return api
      .post(
        `${this.props.apiEndpoint}/referrals/${this.props.referralId}/referral_reminders`,
        {
          reminder: {
            date: iso8601Date(formValues.date),
            note: formValues.note,
          },
        }
      )
      .then((response) => {
        this.props.handleSuccess();
        FlashMessageActions.flashSuccess({
          message: 'You have successfully added a reminder.',
        });
      });
  }

  render() {
    return (
      <FormifiedPresentationComponent
        form="createReminder"
        initialValues={{
          date: tomorrow,
        }}
        onSubmit={this.createReminder}
      />
    );
  }
}

const PresentationComponent = (props) => {
  return (
    <HForm onSubmit={props.handleSubmit}>
      <div className="modal-header">
        <h3>Create Reminder</h3>
      </div>
      <div className="modal-body">
        <p>
          Reminders are a convenient way to defer administrative tasks (like
          phone calls) without letting them slip through the cracks. Once the
          reminder time you specify below has been reached, the system will
          highlight this referral in your referral list and prompt you to take
          action according to the notes you enter below.
        </p>
        <Errors errors={props.error || []} />

        <div className="control-group">
          <label htmlFor="date" className="control-label">
            Date
          </label>
          <div className="controls">
            <Field
              name="date"
              validate={required}
              component={ReminderDateInput}
            />
          </div>
        </div>

        <div className="control-group">
          <label htmlFor="note" className="control-label">
            Note
          </label>
          <div className="controls">
            <Field name="note" validate={required} component={NoteInput} />
          </div>
        </div>
      </div>
      <div className="modal-footer" style={{ textAlign: 'center' }}>
        <button type="submit" className="btn btn-primary">
          Create Reminder
        </button>
      </div>
    </HForm>
  );
};

const FormifiedPresentationComponent = reduxForm({})(PresentationComponent);

ReferralReminderCreator.propTypes = {
  apiEndpoint: PropTypes.string.isRequired,
  referralId: PropTypes.string.isRequired,
  handleSuccess: PropTypes.func,
};

export default connect()(ReferralReminderCreator);
